/** Height of the main app header in px; must match auth layout main offset. */
export const PERIVERSE_HEADER_HEIGHT_PX = 80;
